import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export type component = {
    id: number;
    amount: number;
    attributes: {
        attribute_id: number;
        value: string;
    }[]
}

export interface addProductFields {
    name?: string,
    description?: string,
    serial_no?: string,
    price?: number,
    materials?: component[],
    services?: component[]
}

// Add product state
export interface addProductState {
    fields: addProductFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddProductState: addProductState = {
    fields: {
        name: "",
        description: "",
        serial_no: "",
        price: 0,
        materials: [],
        services: []
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add product slice
export const addProductSlice = createSlice({
    name: 'add_product',
    initialState: initialAddProductState,
    reducers: {
        init: state => initialAddProductState,
        set: ( state, {payload}: PayloadAction<addProductFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        }
    }
})